import { Flex, Spin, Typography } from 'antd'

import type { School } from '../../../../../types'

import { UserTable } from './UserTable'

export const UsersTab = ({ fetch, school }: { fetch: () => Promise<void>; school: School }) => {
    if (!school) {
        return <Spin />
    }

    return (
        <>
            <Flex justify="space-between" align="center">
                <Typography.Title level={4}>School Users</Typography.Title>
            </Flex>
            <UserTable school={school} refetch={fetch} />
        </>
    )
}
